<i2g-job-preview-title
  [title]="file.title"
  [description]="file.description"
  class="preview-title"
></i2g-job-preview-title>

<div class="preview-file-container">
  <div *ngIf="bannerText" class="banner">{{ bannerText }}</div>
  <i2g-file-preview
    [name]="file.title"
    [url]="file.url"
    mimeType="application/pdf"
    class="preview-file"
  ></i2g-file-preview>
</div>

<div class="preview-actions">
  <div
    class="action-container"
    [class.multiple-actions]="viewButtonText && approveButtonText"
  >
    <button
      *ngIf="viewButtonText"
      i2gButton
      buttonStyle="default"
      class="button view-button"
      (click)="onViewClicked()"
    >
      {{ viewButtonText }}
    </button>

    <button
      *ngIf="approveButtonText"
      i2gButton
      buttonStyle="emphasis"
      class="button"
      (click)="onApproveClicked()"
    >
      {{ approveButtonText }}
    </button>
  </div>
</div>
